export function getFormattedCardValues(value: unknown): string {
  const valueType = typeof value;

  switch (valueType) {
    case 'boolean':
      return value ? 'Yes' : 'No';
    case 'string':
      return (value as string).length === 0
        ? 'No data provided'
        : (value as string);
    case 'number':
      return (value as number).toString();
    default:
      return '-';
  }
}
